// extracted by css-extract-rspack-plugin
export default {"cls1":"Accordion-cls1_pjb","cls2":"Accordion-cls2_nwc Accordion-cls1_pjb"};